var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcVideoCall(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "13px",
    viewBox: "0 0 19 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icVideoCall") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1---Conversation",
    transform: "translate(-304.000000, -84.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(293.000000, 76.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5863761,8.37564955 C29.4945009,8.34185532 29.4061537,8.32488706 29.3212601,8.32488706 C29.1303796,8.32488706 28.9715106,8.3893451 28.8441703,8.51790547 L24.5712694,12.6008176 L24.5712694,10.9250507 C24.5712694,10.1192184 24.2726194,9.43038525 23.6753194,8.85819558 C23.0779823,8.28607705 22.3589496,8 21.517627,8 L14.0534938,8 C13.2124313,8 12.4931757,8.28607705 11.8958014,8.85819558 C11.29865,9.43038525 11,10.1192184 11,10.9250507 L11,18.075056 C11,18.8808172 11.29865,19.5696147 11.8958386,20.1417688 C12.4932129,20.7139229 13.2124684,21 14.053531,21 L21.5177013,21 C22.3589867,21 23.0780566,20.7139229 23.6753937,20.1417688 C24.2726937,19.5696147 24.5713437,18.8808528 24.5713437,18.075056 L24.5713437,16.3890085 L28.8442446,20.482059 C28.9715849,20.6105838 29.1304539,20.6750062 29.3213344,20.6750062 C29.406228,20.6750062 29.4945752,20.6580735 29.5864503,20.6243505 C29.8622615,20.5092011 30,20.3095305 30,20.025161 L30,8.9750169 C29.9998886,8.69050505 29.8621501,8.49079894 29.5863761,8.37564955 Z",
    id: "icVideoCall"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVideoCall);
export default __webpack_public_path__ + "static/media/icVideoCall.1bef1569990246042b515fba79b42c1b.svg";
export { ForwardRef as ReactComponent };